import workPeriod from '@/utils/workPeriod';
import workPeriodNavigation from '@/utils/workPeriodNavigation';

export default {
    mixins: [workPeriodNavigation],
    data: () => ({payrollRequestId: 0, payrollRouteRequestId: 0, periodConfirmation: false, periodFormBaselines: {}, reasonPeriodId: null}),
    computed: {
        monthlyDecisionHint() { return `По всем объектам сотрудника за ${workPeriod.monthLabel(this.periodMonth).toLocaleLowerCase('ru')}`; },
        periodNavigationLocked() { return this.pending || this.ratesBusy || this.missingRateBusy || this.periodConfirmation || this.periodGuardPending; },
        timesheetsPeriodLink() {
            const mode = this.$route.query.from === 'fill' ? 'fill' : 'review';
            return {name: 'timesheets', query: {month: mode === 'fill' ? this.resolvePeriod('fill') : this.periodMonth, mode}};
        }
    },
    created() {
        const forms = {openLineEdit: 'edit', openReasonAction: 'reason', newPolicy: 'policy', editPolicy: 'policy',
            newTerm: 'term', editTerm: 'term', newLocation: 'location', editLocation: 'location'};
        Object.keys(forms).forEach(name => {
            const original = this[name];
            this[name] = (...args) => {
                const result = original(...args);
                this.$set(this.periodFormBaselines, forms[name], this.periodFormSnapshot(forms[name]));
                return result;
            };
        });
        ['transferAccounting', 'acceptAccounting', 'paySelected'].forEach(name => {
            const original = this[name];
            this[name] = async (...args) => {
                if (this.periodNavigationLocked || !this.summary) return;
                this.periodConfirmation = true;
                try { await original(...args); } finally { this.periodConfirmation = false; }
            };
        });
    },
    watch: {
        '$route.fullPath'() {
            if (this.$route.fullPath !== this._canonicalPeriodPath) this.loadPayrollRoute();
        }
    },
    beforeDestroy() { this.payrollRequestId += 1; this.payrollRouteRequestId += 1; },
    methods: {
        periodFormSnapshot(name) {
            return JSON.stringify([this[`${name}Form`], name === 'reason' ? this.reasonText : null,
                name === 'term' ? this.termEmployee : null, name === 'location' ? this.locationObject : null]);
        },
        async preparePeriodLeave() {
            if (this.periodNavigationLocked) return false;
            this.periodGuardPending = true;
            try {
                const dirty = this.paymentDirty || this.ratesDirty || this.missingRateDirty || Object.keys(this.periodFormBaselines).some(name => (
                    this[`${name}Visible`] && this.periodFormBaselines[name] !== this.periodFormSnapshot(name)
                ));
                if (!dirty) return true;
                return Boolean(await this.$bvModal.msgBoxConfirm(
                    'Есть несохранённые изменения. Можно остаться и сохранить их или перейти без сохранения.',
                    {title: 'Несохранённые изменения', okTitle: 'Перейти без сохранения', cancelTitle: 'Остаться', okVariant: 'danger'}
                ));
            } finally { this.periodGuardPending = false; }
        },
        async changePeriodMonth(month) {
            if (!workPeriod.validMonth(month) || month === this.periodMonth || this.periodNavigationLocked) return;
            await this.pushPeriodRoute({path: '/payroll', query: {...this.$route.query, month}});
        },
        async refreshPeriod() {
            if (await this.confirmPeriodLeave()) {
                if (this.$refs.accounting) this.$refs.accounting.expandDetails();
                if (this.ratesDirty && this.$refs.ratePreparation) await this.$refs.ratePreparation.load(true);
                this.ratesDirty = false;
                this.missingRateTarget = null; this.missingRateDirty = false;
                this.closePaymentDialog();
                ['edit', 'reason', 'policy', 'term', 'location'].forEach(name => { this[`${name}Visible`] = false; });
                await this.loadSummary();
            }
        },
        async loadPayrollRoute() {
            const request = ++this.payrollRouteRequestId;
            this.payrollRequestId += 1;
            if (this.summary) this.restoreAnalyticsTab = this.canViewCalculation && this.activeTab === (this.isHistoricalPeriod ? 1 : 3);
            // A fresh visit starts with the completed month, not a stale session selection.
            this.periodMonth = workPeriod.resolveMonth({section: 'payroll', queryMonth: this.$route.query.month});
            this.summary = null;
            this.missingRateTarget = null; this.missingRateDirty = false;
            this.closePaymentDialog();
            this.ratesDirty = false;
            this.loading = true;
            this.selectedLineIds = [];
            this.selectedTimesheetIds = [];
            this.openLineIds = [];
            ['edit', 'reason', 'policy', 'term', 'location'].forEach(name => { this[`${name}Visible`] = false; });
            this.reasonPeriodId = null;
            this.rememberPeriod('payroll', {month: this.periodMonth});
            await this.syncPeriodRoute({path: '/payroll', query: {...this.$route.query, month: this.periodMonth}});
            if (request !== this.payrollRouteRequestId) return;
            await this.loadSummary();
        },
        payrollTimesheetLink(id) {
            return {name: 'timesheet', params: {timesheetId: String(id)}, query: {month: this.periodMonth, from: 'payroll'}};
        }
    }
};
